var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItrobes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 41,
    viewBox: "0 0 111 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2002 19.5808V24.8735L31.8384 19.9286V14.7104L22.2002 19.5808Z",
    fill: "url(#paint0_linear_915_49)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3389 9.64111V14.2878L17.0465 16.6235V12.2254L12.3389 9.64111Z",
    fill: "url(#paint1_linear_915_49)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3389 19.009L17.0465 16.6235V27.4575L12.3389 29.7932V19.009Z",
    fill: "url(#paint2_linear_915_49)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8931 15.2071H45.1924V12.7471H47.8931V15.2071ZM45.2172 16.4246H47.9178V26.5877H45.2172V16.4246ZM60.6531 12.8465V15.2816H56.5402V26.5877H53.666V15.2816H49.5531V12.8465H60.6531ZM66.9216 16.201V18.9343C66.7482 18.9095 66.5995 18.9095 66.4756 18.8846C66.3518 18.8846 66.2279 18.8846 66.1535 18.8846C65.0881 18.8846 64.3696 19.2325 63.998 19.9283C63.7997 20.3259 63.7006 20.9222 63.7006 21.7422V26.6125H61.0247V16.4495H63.552V18.2386C63.9732 17.5677 64.3201 17.0956 64.6174 16.8471C65.1129 16.4246 65.7571 16.2259 66.55 16.2259C66.5995 16.2259 66.6491 16.2259 66.6739 16.2259C66.7482 16.1762 66.8225 16.201 66.9216 16.201ZM75.4448 21.5186C75.4448 20.4998 75.2466 19.7046 74.8254 19.158C74.4042 18.6113 73.8096 18.338 73.0415 18.338C72.2734 18.338 71.6788 18.6113 71.2576 19.158C70.8364 19.7046 70.6381 20.4998 70.6381 21.5186C70.6381 22.5374 70.8611 23.3325 71.2576 23.8792C71.6788 24.4259 72.2734 24.724 73.0415 24.724C73.8096 24.724 74.429 24.4507 74.8254 23.8792C75.2466 23.3325 75.4448 22.5374 75.4448 21.5186ZM73.0415 26.9356C71.3071 26.9356 69.9939 26.4137 69.1515 25.3453C68.2843 24.2768 67.8631 23.0095 67.8631 21.5186C67.8631 20.0525 68.2843 18.7853 69.1515 17.6919C69.9939 16.6234 71.3071 16.0768 73.0415 16.0768C74.7759 16.0768 76.089 16.6234 76.9314 17.6919C77.7986 18.7604 78.2198 20.0525 78.2198 21.5186C78.2198 23.0095 77.7986 24.2768 76.9314 25.3453C76.089 26.4137 74.8006 26.9356 73.0415 26.9356ZM89.8649 21.3695C89.8649 22.9598 89.4933 24.2519 88.75 25.2956C88.0067 26.3392 86.966 26.861 85.6281 26.861C84.7857 26.861 84.1167 26.6871 83.5964 26.364C83.2991 26.1653 82.9522 25.8174 82.6053 25.3204V26.5877H80.0285V12.8465H82.6797V17.7416C83.0265 17.2695 83.3734 16.8968 83.7946 16.6483C84.2654 16.3501 84.8848 16.1762 85.6281 16.1762C86.966 16.1762 88.0067 16.6483 88.75 17.6174C89.4933 18.6113 89.8649 19.8537 89.8649 21.3695ZM87.0899 21.6677C87.0899 20.9471 86.9908 20.3507 86.8174 19.8786C86.4705 18.984 85.8015 18.5368 84.86 18.5368C83.8937 18.5368 83.2495 18.984 82.8779 19.8537C82.7044 20.3259 82.6053 20.9222 82.6053 21.6677C82.6053 22.5374 82.8035 23.258 83.1752 23.8295C83.5468 24.401 84.1415 24.6992 84.9343 24.6992C85.6033 24.6992 86.1484 24.4259 86.5201 23.8792C86.8917 23.2828 87.0899 22.5622 87.0899 21.6677ZM93.7053 20.475H97.8183C97.7687 19.7792 97.5705 19.2325 97.1741 18.8846C96.8024 18.5119 96.3317 18.338 95.7618 18.338C95.1424 18.338 94.6716 18.5368 94.3247 18.9095C94.0026 19.3071 93.8044 19.8289 93.7053 20.475ZM99.7261 18.1392C100.123 18.7356 100.37 19.4313 100.494 20.2265C100.568 20.6986 100.593 21.3695 100.568 22.2392H93.631C93.6805 23.258 94.0026 23.9786 94.5973 24.3762C94.9689 24.6246 95.3902 24.7489 95.9105 24.7489C96.4556 24.7489 96.9015 24.5998 97.2484 24.2768C97.4218 24.1028 97.5953 23.8792 97.7439 23.581H100.445C100.37 24.1774 100.073 24.7986 99.5031 25.4198C98.6359 26.4137 97.4218 26.9107 95.8609 26.9107C94.5725 26.9107 93.4328 26.4883 92.4417 25.6683C91.4506 24.8234 90.9551 23.4816 90.9551 21.5931C90.9551 19.8289 91.4011 18.4871 92.293 17.5428C93.185 16.5986 94.3495 16.1265 95.7618 16.1265C96.6042 16.1265 97.3723 16.2756 98.0413 16.5986C98.735 16.9465 99.2801 17.4434 99.7261 18.1392ZM104.434 23.3574C104.483 23.8295 104.607 24.1525 104.805 24.3762C105.127 24.724 105.747 24.898 106.614 24.898C107.134 24.898 107.556 24.8234 107.853 24.6743C108.15 24.5253 108.324 24.2768 108.324 23.9786C108.324 23.6804 108.2 23.4568 107.952 23.3077C107.704 23.1586 106.787 22.8853 105.177 22.5125C104.037 22.2143 103.22 21.8665 102.749 21.444C102.278 21.0216 102.055 20.4004 102.055 19.6053C102.055 18.661 102.427 17.8659 103.145 17.195C103.889 16.524 104.904 16.1762 106.242 16.1762C107.506 16.1762 108.547 16.4246 109.339 16.9465C110.132 17.4683 110.603 18.338 110.702 19.5804H108.051C108.002 19.2325 107.927 18.9592 107.754 18.7604C107.456 18.4125 106.961 18.2137 106.267 18.2137C105.697 18.2137 105.276 18.2883 105.028 18.4871C104.781 18.661 104.657 18.8846 104.657 19.1331C104.657 19.4313 104.781 19.655 105.053 19.804C105.301 19.9531 106.242 20.2016 107.828 20.5495C108.893 20.798 109.686 21.1707 110.207 21.6677C110.727 22.1895 111 22.8107 111 23.581C111 24.5998 110.628 25.4198 109.885 26.041C109.141 26.6871 107.977 27.0101 106.416 27.0101C104.83 27.0101 103.641 26.6622 102.898 25.9913C102.129 25.3204 101.758 24.4507 101.758 23.4071H104.434V23.3574Z",
    fill: "#00339F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2002 19.5808V24.8735L31.8384 19.9286V14.7104L22.2002 19.5808Z",
    fill: "url(#paint3_linear_915_49)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8879 24.5254L31.8384 29.7933L22.2002 24.8733V19.5806L31.8879 24.5254Z",
    fill: "url(#paint4_linear_915_49)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4678 12.2005L22.1506 9.86475L31.8383 14.7102V19.9284L17.4678 12.2005Z",
    fill: "url(#paint5_linear_915_49)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4408 0C9.14263 0 0 9.16909 0 20.5C0 31.8309 9.14263 41 20.4408 41C31.7391 41 40.8817 31.8309 40.8817 20.5C40.8817 9.16909 31.7143 0 20.4408 0ZM21.3824 39.6582C10.7531 39.6582 2.1308 31.0855 2.1308 20.5C2.1308 9.91455 10.7531 1.34182 21.3824 1.34182C32.0116 1.34182 40.6339 9.91455 40.6339 20.4752C40.6339 31.0358 32.0116 39.6582 21.3824 39.6582Z",
    fill: "url(#paint6_linear_915_49)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_49",
    x1: 22.2017,
    y1: 19.7912,
    x2: 31.8428,
    y2: 19.7912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_49",
    x1: 12.3408,
    y1: 13.1318,
    x2: 17.0417,
    y2: 13.1318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_915_49",
    x1: 12.3408,
    y1: 23.1997,
    x2: 17.0417,
    y2: 23.1997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_915_49",
    x1: 25.1665,
    y1: 22.7325,
    x2: 30.7328,
    y2: 13.8689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0498,
    stopColor: "#231F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1048,
    stopColor: "#21212B",
    stopOpacity: 0.856
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2022,
    stopColor: "#1C2649",
    stopOpacity: 0.6009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3298,
    stopColor: "#142E79",
    stopOpacity: 0.267
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4317,
    stopColor: "#0C36A5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#0E3498",
    stopOpacity: 0.0407
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4789,
    stopColor: "#152D73",
    stopOpacity: 0.173
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5167,
    stopColor: "#1A2855",
    stopOpacity: 0.3119
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5563,
    stopColor: "#1E243E",
    stopOpacity: 0.4573
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5985,
    stopColor: "#21212D",
    stopOpacity: 0.6121
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645,
    stopColor: "#222023",
    stopOpacity: 0.7827
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7042,
    stopColor: "#231F20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_915_49",
    x1: 22.2017,
    y1: 24.6839,
    x2: 31.8909,
    y2: 24.6839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_915_49",
    x1: 17.4735,
    y1: 14.8946,
    x2: 31.8428,
    y2: 14.8946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_915_49",
    x1: -0.00396429,
    y1: 20.4876,
    x2: 41.9503,
    y2: 20.4876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00339F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3AAB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItrobes);
export default __webpack_public_path__ + "static/media/itrobes.77da2dc77578714a566b95326b27493a.svg";
export { ForwardRef as ReactComponent };